import { render, staticRenderFns } from "./VideoSeriesVideoListSection.vue?vue&type=template&id=b8aab126&"
import script from "./VideoSeriesVideoListSection.vue?vue&type=script&lang=js&"
export * from "./VideoSeriesVideoListSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports